// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Arial, sans-serif;
}

.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  background: #f4f4f4;
}
.login-logo {
  text-align: center;
  margin-bottom: 10px;
}

.login-logo-img {
  max-width: 100%;
  height: 20%;
}

.login-container {
  display: flex;
  width: 150%;
  position: relative;
  height: 80%;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin-left: -30%;
  flex: 10 1;
}

.login-image {
  flex: 12 1;
  background-color: #000;
}

.login-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-form {
  flex: 12 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.error-messages {
  font-size: 14px;
  color: red;
  margin-bottom: 2%;
}

.h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
  text-align: start;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}

.input {
  width: 50%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #333;
  border-radius: 5px;
}

.input:focus {
  border-color: #007bff;
  outline: none;
}

.form-options {
  width: 100%;
  margin: 0 0 20px 0;
  text-align: right;
}

.form-options a {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
}

.btn-login {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: #fff;
  background-color: #79c42b;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-login:hover {
  background-color: #79c42b;
}
/* Login.css */
.login-page {
  position: fixed; /* Make the login form overlay fixed */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10; /* Ensure it's on top of the content */
}

.login-modal {
  background: white;
  padding: 0;
  border-radius: 8px;
  width: 400px;
  text-align: center;
}

.login-close-button {
  position: absolute;
  top: 20px !important; /* Set a fixed top distance */
  right: 20px !important; /* Stick to the right with a fixed distance */

  background-color: transparent !important; /* Transparent background */
  border: none !important; /* Remove default border */
  font-size: 30px !important; /* Adjust size of the cross '×' */
  font-weight: bold !important;
  color: rgb(135, 146, 138) !important; /* Initial color */
  cursor: pointer !important; /* Show pointer cursor on hover */
  transition: color 0.3s ease !important; /* Smooth color transition */
}

.login-close-button:hover {
  color: rgb(136, 117, 117) !important; /* Change color on hover */
}

.login-modal form input {
  width: 92%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.login-modal form button {
  width: 100%;
  padding: 10px;
  background-color: #79c42b;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.login-modal form button:hover {
  background-color: #79c42b;
}
.login-modal form button {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.login-modal form button:hover {
  background-color: #45a049;
}
.open-login-btn {
  background-color: #4caf50;
  color: white;
  bottom: 50%;

  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin: 20px;
}

.open-login-btn:hover {
  background-color: #45a049;
}
/* Open Login Button (inside Login component) */
.btn-open-login {
  background-color: #4caf50; /* Green background */
  color: white; /* White text */
  border: none; /* No border */
  padding: 10px 20px; /* Padding for size */
  text-align: center; /* Text centered */
  text-decoration: none; /* No underlining */
  font-size: 16px; /* Font size */
  cursor: pointer; /* Pointer cursor on hover */
  border-radius: 5px; /* Rounded corners */
  transition: background-color 0.3s ease; /* Smooth background change on hover */
  position: absolute; /* Absolute positioning */
  right: 70px; /* Position the button on the right side */
  top: 20px; /* Position it a bit below the top */
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s ease-in-out, background-color 0.6s ease-in-out;
}

/* Hover effect for the button */
.btn-open-login:hover {
  background-color: #3e8e41;
  transform: scale(0.98); /* Slightly darker green on hover */
}
/* Focus state for better accessibility */
.btn-open-login:focus {
  outline: none; /* Remove default outline */
  box-shadow: 0 0 5px rgba(0, 255, 0, 0.5); /* Green focus ring */
}
/* Active state when button is clicked */
.btn-open-login:active {
  background-color: #3e8e41; /* Even darker green when clicked */
  transform: scale(0.98); /* Slightly shrink the button */
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  flex: 1 1;
  padding-right: 2.5em; /* room for the icon */
}

/* the eye icon as a span */
.toggle-password-icon {
  position: absolute;
  right: 0.5em;
  cursor: pointer;
  font-size: 1.1em;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  /* make it focusable for accessibility */
}

.toggle-password-icon:hover {
  color: #333;
}

/* General styles remain the same */

/* Mobile View */
/* General styles remain the same */

/* Mobile View */
@media (max-width: 768px) {
  .login-container {
    width: 100%;
    height: auto;
    margin: 0 auto; /* Center align the container */
    flex-direction: column; /* Stack vertically */
    align-items: center; /* Center align vertically */
    justify-content: center; /* Center align horizontally */
    box-shadow: none;
    border-radius: 0;
  }
  .form-options {
    margin-bottom: 10px;
    text-align: right;
  }
  .login-modal form button {
    width: 112%;
    padding: 10px;
    background-color: #079c40;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
  }

  .login-image {
    display: none;
    flex: 0 1;

    display: block;
    width: 100%; /* Adjust width to fill container */
    height: 200px; /* Fixed height for mobile */
    background-color: #000;
  }

  .login-image img {
    display: none;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .login-form {
    flex: 0 1;
    padding: 0;
    width: 100%; /* Full width */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  label {
    font-size: 10px; /* Smaller label text */
    margin-bottom: 3px; /* Adjust margin for compact look */
  }

  input {
    width: 100%; /* Make input fields take full width */
    padding: 6px; /* Smaller padding for inputs */
    font-size: 12px; /* Smaller font size */
  }

  .btn-login {
    width: 100%;
  }

  .form-options {
    text-align: center; /* Center align links */
  }

  .login-logo-img {
    height: auto; /* Allow the logo to resize proportionally */
    max-width: 80%;
  }

  .login-close-button {
    margin-top: 0% !important;
    left: 80% !important;
    font-size: 28px !important; /* Slightly smaller for mobile */
  }

  .open-login-btn {
    font-size: 14px; /* Adjust button size */
    padding: 8px 20px;
    position: static; /* Make it inline for mobile */
    margin: 12px auto;
    display: block;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 16px; /* Adjust heading size */
  }

  label {
    font-size: 10px; /* Smaller label text */
    margin-bottom: 2px; /* Adjust margin for compact look */
  }

  input {
    padding: 5px; /* Smaller padding for inputs */
    font-size: 11px;
  }

  .btn-login {
    font-size: 12px; /* Smaller button text */
  }

  .login-modal {
    width: 90%; /* Make modal fit smaller screens */
  }

  .login-image {
    flex: 0 1;
    width: 100%; /* Ensure the image fills container */
    height: 150px; /* Fixed height for very small screens */
  }

  .login-form {
    width: 100%; /* Match the image's width proportion */
    padding: 10px; /* Reduce padding for compact view */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;;EAEb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,UAAQ;AACV;;AAEA;EACE,UAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA,cAAc;AACd;EACE,eAAe,EAAE,sCAAsC;EACvD,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B,EAAE,gCAAgC;EAChE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,sCAAsC;AACrD;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB,EAAE,6BAA6B;EACnD,sBAAsB,EAAE,6CAA6C;;EAErE,wCAAwC,EAAE,2BAA2B;EACrE,uBAAuB,EAAE,0BAA0B;EACnD,0BAA0B,EAAE,iCAAiC;EAC7D,4BAA4B;EAC5B,oCAAoC,EAAE,kBAAkB;EACxD,0BAA0B,EAAE,iCAAiC;EAC7D,sCAAsC,EAAE,4BAA4B;AACtE;;AAEA;EACE,oCAAoC,EAAE,0BAA0B;AAClE;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;;EAEX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA,+CAA+C;AAC/C;EACE,yBAAyB,EAAE,qBAAqB;EAChD,YAAY,EAAE,eAAe;EAC7B,YAAY,EAAE,cAAc;EAC5B,kBAAkB,EAAE,qBAAqB;EACzC,kBAAkB,EAAE,kBAAkB;EACtC,qBAAqB,EAAE,mBAAmB;EAC1C,eAAe,EAAE,cAAc;EAC/B,eAAe,EAAE,4BAA4B;EAC7C,kBAAkB,EAAE,oBAAoB;EACxC,sCAAsC,EAAE,sCAAsC;EAC9E,kBAAkB,EAAE,yBAAyB;EAC7C,WAAW,EAAE,0CAA0C;EACvD,SAAS,EAAE,oCAAoC;EAC/C,aAAa;EACb,UAAU;EACV,uEAAuE;AACzE;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,sBAAsB,EAAE,mCAAmC;AAC7D;AACA,yCAAyC;AACzC;EACE,aAAa,EAAE,2BAA2B;EAC1C,wCAAwC,EAAE,qBAAqB;AACjE;AACA,wCAAwC;AACxC;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,sBAAsB,EAAE,+BAA+B;AACzD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,oBAAoB,EAAE,sBAAsB;AAC9C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA,mCAAmC;;AAEnC,gBAAgB;AAChB,mCAAmC;;AAEnC,gBAAgB;AAChB;EACE;IACE,WAAW;IACX,YAAY;IACZ,cAAc,EAAE,+BAA+B;IAC/C,sBAAsB,EAAE,qBAAqB;IAC7C,mBAAmB,EAAE,4BAA4B;IACjD,uBAAuB,EAAE,8BAA8B;IACvD,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAO;;IAEP,cAAc;IACd,WAAW,EAAE,mCAAmC;IAChD,aAAa,EAAE,4BAA4B;IAC3C,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,UAAU;IACV,WAAW,EAAE,eAAe;IAC5B,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe,EAAE,uBAAuB;IACxC,kBAAkB,EAAE,mCAAmC;EACzD;;EAEA;IACE,WAAW,EAAE,sCAAsC;IACnD,YAAY,EAAE,+BAA+B;IAC7C,eAAe,EAAE,sBAAsB;EACzC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB,EAAE,uBAAuB;EAC7C;;EAEA;IACE,YAAY,EAAE,4CAA4C;IAC1D,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B,EAAE,gCAAgC;EAC9D;;EAEA;IACE,eAAe,EAAE,uBAAuB;IACxC,iBAAiB;IACjB,gBAAgB,EAAE,8BAA8B;IAChD,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,eAAe,EAAE,uBAAuB;IACxC,kBAAkB,EAAE,mCAAmC;EACzD;;EAEA;IACE,YAAY,EAAE,+BAA+B;IAC7C,eAAe;EACjB;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,UAAU,EAAE,mCAAmC;EACjD;;EAEA;IACE,SAAO;IACP,WAAW,EAAE,qCAAqC;IAClD,aAAa,EAAE,wCAAwC;EACzD;;EAEA;IACE,WAAW,EAAE,uCAAuC;IACpD,aAAa,EAAE,oCAAoC;IACnD,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  font-family: Arial, sans-serif;\n}\n\n.login-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n\n  background: #f4f4f4;\n}\n.login-logo {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.login-logo-img {\n  max-width: 100%;\n  height: 20%;\n}\n\n.login-container {\n  display: flex;\n  width: 150%;\n  position: relative;\n  height: 80%;\n  background: #fff;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  margin-left: -30%;\n  flex: 10;\n}\n\n.login-image {\n  flex: 12;\n  background-color: #000;\n}\n\n.login-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.login-form {\n  flex: 12;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.error-messages {\n  font-size: 14px;\n  color: red;\n  margin-bottom: 2%;\n}\n\n.h2 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 15px;\n  text-align: start;\n}\n\n.label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #333;\n}\n\n.input {\n  width: 50%;\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #333;\n  border-radius: 5px;\n}\n\n.input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.form-options {\n  width: 100%;\n  margin: 0 0 20px 0;\n  text-align: right;\n}\n\n.form-options a {\n  color: #007bff;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.btn-login {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  color: #fff;\n  background-color: #79c42b;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.btn-login:hover {\n  background-color: #79c42b;\n}\n/* Login.css */\n.login-page {\n  position: fixed; /* Make the login form overlay fixed */\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10; /* Ensure it's on top of the content */\n}\n\n.login-modal {\n  background: white;\n  padding: 0;\n  border-radius: 8px;\n  width: 400px;\n  text-align: center;\n}\n\n.login-close-button {\n  position: absolute;\n  top: 20px !important; /* Set a fixed top distance */\n  right: 20px !important; /* Stick to the right with a fixed distance */\n\n  background-color: transparent !important; /* Transparent background */\n  border: none !important; /* Remove default border */\n  font-size: 30px !important; /* Adjust size of the cross '×' */\n  font-weight: bold !important;\n  color: rgb(135, 146, 138) !important; /* Initial color */\n  cursor: pointer !important; /* Show pointer cursor on hover */\n  transition: color 0.3s ease !important; /* Smooth color transition */\n}\n\n.login-close-button:hover {\n  color: rgb(136, 117, 117) !important; /* Change color on hover */\n}\n\n.login-modal form input {\n  width: 92%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.login-modal form button {\n  width: 100%;\n  padding: 10px;\n  background-color: #79c42b;\n  border: none;\n  border-radius: 4px;\n  color: white;\n  cursor: pointer;\n}\n\n.login-modal form button:hover {\n  background-color: #79c42b;\n}\n.login-modal form button {\n  width: 100%;\n  padding: 10px;\n  background-color: #4caf50;\n  border: none;\n  border-radius: 4px;\n  color: white;\n  cursor: pointer;\n}\n\n.login-modal form button:hover {\n  background-color: #45a049;\n}\n.open-login-btn {\n  background-color: #4caf50;\n  color: white;\n  bottom: 50%;\n\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin: 20px;\n}\n\n.open-login-btn:hover {\n  background-color: #45a049;\n}\n/* Open Login Button (inside Login component) */\n.btn-open-login {\n  background-color: #4caf50; /* Green background */\n  color: white; /* White text */\n  border: none; /* No border */\n  padding: 10px 20px; /* Padding for size */\n  text-align: center; /* Text centered */\n  text-decoration: none; /* No underlining */\n  font-size: 16px; /* Font size */\n  cursor: pointer; /* Pointer cursor on hover */\n  border-radius: 5px; /* Rounded corners */\n  transition: background-color 0.3s ease; /* Smooth background change on hover */\n  position: absolute; /* Absolute positioning */\n  right: 70px; /* Position the button on the right side */\n  top: 20px; /* Position it a bit below the top */\n  z-index: 1000;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out, background-color 0.6s ease-in-out;\n}\n\n/* Hover effect for the button */\n.btn-open-login:hover {\n  background-color: #3e8e41;\n  transform: scale(0.98); /* Slightly darker green on hover */\n}\n/* Focus state for better accessibility */\n.btn-open-login:focus {\n  outline: none; /* Remove default outline */\n  box-shadow: 0 0 5px rgba(0, 255, 0, 0.5); /* Green focus ring */\n}\n/* Active state when button is clicked */\n.btn-open-login:active {\n  background-color: #3e8e41; /* Even darker green when clicked */\n  transform: scale(0.98); /* Slightly shrink the button */\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  flex: 1;\n  padding-right: 2.5em; /* room for the icon */\n}\n\n/* the eye icon as a span */\n.toggle-password-icon {\n  position: absolute;\n  right: 0.5em;\n  cursor: pointer;\n  font-size: 1.1em;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* make it focusable for accessibility */\n}\n\n.toggle-password-icon:hover {\n  color: #333;\n}\n\n/* General styles remain the same */\n\n/* Mobile View */\n/* General styles remain the same */\n\n/* Mobile View */\n@media (max-width: 768px) {\n  .login-container {\n    width: 100%;\n    height: auto;\n    margin: 0 auto; /* Center align the container */\n    flex-direction: column; /* Stack vertically */\n    align-items: center; /* Center align vertically */\n    justify-content: center; /* Center align horizontally */\n    box-shadow: none;\n    border-radius: 0;\n  }\n  .form-options {\n    margin-bottom: 10px;\n    text-align: right;\n  }\n  .login-modal form button {\n    width: 112%;\n    padding: 10px;\n    background-color: #079c40;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    cursor: pointer;\n  }\n\n  .login-image {\n    display: none;\n    flex: 0;\n\n    display: block;\n    width: 100%; /* Adjust width to fill container */\n    height: 200px; /* Fixed height for mobile */\n    background-color: #000;\n  }\n\n  .login-image img {\n    display: none;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .login-form {\n    flex: 0;\n    padding: 0;\n    width: 100%; /* Full width */\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  label {\n    font-size: 10px; /* Smaller label text */\n    margin-bottom: 3px; /* Adjust margin for compact look */\n  }\n\n  input {\n    width: 100%; /* Make input fields take full width */\n    padding: 6px; /* Smaller padding for inputs */\n    font-size: 12px; /* Smaller font size */\n  }\n\n  .btn-login {\n    width: 100%;\n  }\n\n  .form-options {\n    text-align: center; /* Center align links */\n  }\n\n  .login-logo-img {\n    height: auto; /* Allow the logo to resize proportionally */\n    max-width: 80%;\n  }\n\n  .login-close-button {\n    margin-top: 0% !important;\n    left: 80% !important;\n    font-size: 28px !important; /* Slightly smaller for mobile */\n  }\n\n  .open-login-btn {\n    font-size: 14px; /* Adjust button size */\n    padding: 8px 20px;\n    position: static; /* Make it inline for mobile */\n    margin: 12px auto;\n    display: block;\n  }\n}\n\n@media (max-width: 480px) {\n  h2 {\n    font-size: 16px; /* Adjust heading size */\n  }\n\n  label {\n    font-size: 10px; /* Smaller label text */\n    margin-bottom: 2px; /* Adjust margin for compact look */\n  }\n\n  input {\n    padding: 5px; /* Smaller padding for inputs */\n    font-size: 11px;\n  }\n\n  .btn-login {\n    font-size: 12px; /* Smaller button text */\n  }\n\n  .login-modal {\n    width: 90%; /* Make modal fit smaller screens */\n  }\n\n  .login-image {\n    flex: 0;\n    width: 100%; /* Ensure the image fills container */\n    height: 150px; /* Fixed height for very small screens */\n  }\n\n  .login-form {\n    width: 100%; /* Match the image's width proportion */\n    padding: 10px; /* Reduce padding for compact view */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
